import React from 'react';
import SectionLabel from './SectionLabel';
import Reveal from './Reveal';
import { Database, LineChart, Handshake, Languages } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';

const ICONS = [Database, LineChart, Handshake, Languages];

export default function AboutStats() {
  const { t } = useI18n();
  const stats = t('about_stats.stats') || [];
  const principles = t('about_stats.principles') || [];
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8 space-y-5">
            <SectionLabel>{t('about_stats.tag')}</SectionLabel>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
              {t('about_stats.title_a')} <br className="hidden md:block" />
              {t('about_stats.title_b')} <br className="hidden md:block" />
              <span className="text-gradient-green">{t('about_stats.title_c')}</span>
            </h2>
          </div>
          <div className="lg:col-span-4 space-y-4 text-sm text-slate-700/70 leading-relaxed">
            <div className="text-[11px] tracking-[0.22em] uppercase text-blue-600">{t('about_stats.story_label')}</div>
            <p>{t('about_stats.story_1')}</p>
            <p>{t('about_stats.story_2')}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-16">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 60}>
              <div className="relative rounded-2xl border border-blue-500/10 bg-white p-6 overflow-hidden group hover:border-blue-500/30 card-lift">
                <div className="font-display text-4xl md:text-5xl font-semibold text-gradient-green leading-none">{s.value}</div>
                <div className="mt-3 text-xs text-slate-700/60">{s.label}</div>
                <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </Reveal>
          ))}
        </div>
        <div className="space-y-6">
          <div className="text-[11px] tracking-[0.22em] uppercase text-blue-600">{t('about_stats.why_label')}</div>
          <h3 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 max-w-3xl leading-tight">
            {t('about_stats.why_title_a')} <span className="text-gradient-green">{t('about_stats.why_title_b')}</span>
          </h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mt-8">
            {principles.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={p.title} delay={i * 60}>
                  <div className="group h-full rounded-2xl border border-blue-500/10 bg-white p-6 card-lift hover:border-blue-500/30">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-500/10 border border-blue-500/20 mb-5">
                      <Icon className="h-5 w-5 text-blue-600" strokeWidth={1.7} />
                    </div>
                    <h4 className="font-display text-lg font-medium text-slate-900 mb-2">{p.title}</h4>
                    <p className="text-sm text-slate-700/70 leading-relaxed">{p.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
